/**
 * @description: 门票营业汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="tsr-myh-report">
        <div class="myh-list">
            <el-form :inline="true" size="small" :model="myh_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="myh_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="myh_list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="myh_list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="myh_list_form.shop_id" filterable placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="门票类型">
                    <el-select v-model="myh_list_form.category_id" filterable clearable placeholder="请选择门票类型">
                        <el-option v-for="item in ticket_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="名称">
                    <el-input placeholder="请输入名称" v-model="myh_list_form.ticket_name"></el-input>
                </el-form-item>
                <el-form-item label="是否扣除平台票金额">
                    <el-select v-model="myh_list_form.deduct_group_price">
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="-1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getMyhList(1)">查询</el-button>
                    <el-button @click="myhExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="myh_list">
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="category_name" label="类型"></el-table-column>
                <el-table-column prop="ticket_name" label="名称"></el-table-column>
                <el-table-column prop="quantity" label="数量"></el-table-column>
                <el-table-column prop="discount_price" label="实收金额"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="setPageParams(scope.row.shop_id)">详情</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-3">总数量:</label>
                    <div class="list-total">{{myh_quantity}}</div>
                    <label class="list-label-4">实收总额:</label>
                    <div class="list-total">{{myh_discount_price}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="myh_list_page"
                    :total="myh_list_total"
                    @current-change="getMyhList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="myh_list_export">
                <h2>请选择导出报表需要的显示的字段</h2>
                <el-checkbox :indeterminate="myh_export_sign" v-model="myh_export_all" @change="myhExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="myh_export_ids" @change="myhExportChange">
                    <el-checkbox label="shop_name">门店</el-checkbox>
                    <el-checkbox label="category_name">类型</el-checkbox>
                    <el-checkbox label="ticket_name">名称</el-checkbox>
                    <el-checkbox label="quantity">数量</el-checkbox>
                    <el-checkbox label="discount_price">实收金额</el-checkbox>
                </el-checkbox-group>
                <h2>请选择导出报表的文件格式</h2>
                <el-radio v-model="myh_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="myh_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                myh_mym_menu: {},
                loading: false,
                shop_list: [],
                ticket_type_list: [],
                myh_list_form: {
                    start_time: moment().format('YYYY-MM-DD 08:00'),
                    end_time: moment().add(1, 'day').format('YYYY-MM-DD 08:00'),
                    shop_id: '',
                    category_id: '',
                    ticket_name: '',
                    deduct_group_price: '1'
				},
                myh_quantity: '',
                myh_discount_price: '',
				myh_list: [],
				myh_list_page: 1,
                myh_list_total: 0,
                myh_export_sign: false,
				myh_export_all: false,
                myh_export_ids: [],
                myh_export_list: ['shop_name', 'category_name', 'ticket_name', 'quantity', 'discount_price'],
                myh_export_type: '1',
            }
        },
        computed: {
            menunew() {
				return JSON.parse(this.$store.state.menunew)
			}
        },
        mounted: function() {
            // 跳转菜单
			this.getPageMenu()
            this.initDate()
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.myh_list_form.shop_id = this.shop_list[0].id
                this.getTicketType()
                this.getMyhList(1)
            })
        },
        methods: {
            // 跳转菜单
			getPageMenu: function() {
				this.menunew.forEach(i => {
					if(i.id == '544') {
						i.submenu.forEach(j => {
							if(j.id == '1239') {
                                j.submenu.forEach(k => {
                                    if(k.id == '1241') {
                                        // 门票营业明细报表
                                        this.myh_mym_menu = k
                                    }
                                })
							}
						})
					}
				})
			},
			// 跳转参数
			setPageParams(shop_id) {
				const obj = {
					name: 'tsr_mym_report',
					params: {
                        start_time: this.myh_list_form.start_time,
                        end_time: this.myh_list_form.end_time,
                        shop_id: shop_id,
                        shopping_guide: '',
                        deduct_group_price: this.myh_list_form.deduct_group_price
					}
				}
				this.$emit("pageLink", this.myh_mym_menu, obj)
			},
            // 初始化日期插件
            initDate: function() {
                const _this = this
                $(_this.$refs.myh_list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.myh_list_form.start_time = start.format('YYYY-MM-DD 08:00')
                    _this.myh_list_form.end_time = end.format('YYYY-MM-DD 08:00')
                })
            },
            // 门店
            getShop: function(resolve) {
                const _this = this

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result
                        _this.shop_list.shift()
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this)
                        layer.msg(res.data.response.error_msg)
                    }
                })
                .catch(err => {
                    layer.msg('出错啦')
                })
            },
            // 获取门票类型
            getTicketType() {
                const _this = this

                Vue.axios.post('publicData/api_getTicketCategory', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "type": 0
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.ticket_type_list = res.data.response.result
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this)
                        layer.msg(res.data.response.error_msg)
                    }
                })
                .catch(err => {
                    layer.msg('出错啦')
                })
            },



            getMyhList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('TicketOrder/getTicketCountList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.myh_list_form.start_time,
                            "end_time": _this.myh_list_form.end_time,
							"shop_id": _this.myh_list_form.shop_id,
							"category_id": _this.myh_list_form.category_id,
							"ticket_name": _this.myh_list_form.ticket_name,
							"deduct_group_price": _this.myh_list_form.deduct_group_price
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.myh_list_total = Number(res.data.response.result.total_data.total)
							_this.myh_quantity = res.data.response.result.total_data.quantity
							_this.myh_discount_price = res.data.response.result.total_data.discount_price
						}
						_this.myh_list = res.data.response.result.rows
						_this.loading = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
            // 导出
            myhExportAll(val) {
				this.myh_export_ids = val ? this.myh_export_list : [];
				this.myh_export_sign = false;
			},
			myhExportChange(val) {
				const len = val.length;
				this.myh_export_all = len === this.myh_export_list.length;
				this.myh_export_sign = len > 0 && len < this.myh_export_list.length;
			},
            myhExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "TicketOrder/exportTicketCountList"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.myh_export_ids = res.data.response.result.export_fields;
                            _this.myh_export_type = res.data.response.result.export_type;
                        } else {
                            _this.myh_export_ids = _this.myh_export_list;
                            _this.myh_export_type = '1';
                        }
                        _this.myhExportChange(_this.myh_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });
                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.myh_list_export)
                }, function() {
                    _this.myhExport();
                });
            },
            myhExport: function() {
                window.location.href = Vue.ctUrl + "TicketOrder/exportTicketCountList" +
                    "?start_time=" + this.myh_list_form.start_time +
                    "&end_time=" + this.myh_list_form.end_time +
                    "&shop_id=" + this.myh_list_form.shop_id +
                    "&category_id=" + this.myh_list_form.category_id +
                    "&ticket_name=" + this.myh_list_form.ticket_name +
                    "&deduct_group_price=" + this.myh_list_form.deduct_group_price +
                    "&export_fields=" + JSON.stringify(this.myh_export_ids) +
                    "&export_type=" + this.myh_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .export-wrap {
        h2 {
            margin: 20px 0 15px 0;
            font-size: 16px;
        }
    }
</style>